import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { AppConfigData } from 'app/app.config.data';
// import { Observable } from 'rxjs/Observable';


const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
const fhirHeaders= new HttpHeaders().set('Content-Type', 'application/fhir+json');
const downloadPdfhttpHeaders = new HttpHeaders().set('Content-Type', 'application/pdf');
const XML_HEADER = new HttpHeaders().set('Content-Type', 'application/xml');
const xm=new HttpHeaders().set( 'Content-Type','multipart/form-data' );
const audioHeader=new HttpHeaders().set('Content-Type','multipart/form-data');
const ZIP_HEADER = new HttpHeaders().set('Content-Type', 'application/octet-stream');


@Injectable({
  providedIn: 'root'
})
export class GlobalApiService {

  pdfHeader =  {
    'Accept': 'application/pdf',
    'Content-Type': 'application/json'
  }
  expHeader = {
    'Accept': 'application/force-download',
    'Content-Type': 'application/json'
};

  constructor(private http: HttpClient) { }

  public getData<T = any>(route: string): Observable<HttpResponse<T>> {
    return this.http.get<T>(
         this.createCompleteRoute(route),
         { observe: 'response', headers: httpHeaders});
  }
  public getFHIRData(route: string): Observable<HttpResponse<any>> {
    return this.http.get(
         this.createCompleteFHIRRoute(route),
         { observe: 'response', headers: httpHeaders});
  }
  public postFHIRData(route: string, body): Observable<HttpResponse<any>> {
    return this.http.post(this.createCompleteFHIRRoute(route),
        body, { observe: 'response', headers: httpHeaders});
  }
  public getDatafromKpai(route: string): Observable<HttpResponse<any>> {
    return this.http.get('http://192.168.21.195:4990/kpaiservices/api/'+route,
         { observe: 'response', headers: httpHeaders});
  }
  public postDatafromKpai(route: string, body): Observable<HttpResponse<any>> {
    return this.http.post('http://192.168.21.195:4990/kpaiservices/api/'+route,
        body, { observe: 'response', headers: httpHeaders});
  }
  public getDataDirectUrl(route: string): Observable<HttpResponse<any>> {
    httpHeaders.append('Access-Control-Allow-Origin','*');
    return this.http.get(
         route,
         { observe: 'response', headers: httpHeaders});
  }
  public postDataDirectUrl(route: string,body): Observable<HttpResponse<any>> {
    return this.http.post(
         route,body,
         { observe: 'response', headers: httpHeaders});
  }

  public postData<T = any>(route: string, body): Observable<HttpResponse<T>> {
    return this.http.post<T>(this.createCompleteRoute(route),
        body, { observe: 'response', headers: httpHeaders});
  }

  public updateData(route: string, body): Observable<HttpResponse<any>> {
    return this.http.put(this.createCompleteRoute(route),
    body, { observe: 'response', headers: httpHeaders});
  }

  public deleteData(route: string): Observable<HttpResponse<any>> {
    return this.http.delete(this.createCompleteRoute(route),
          { observe: 'response', headers: httpHeaders});
  }

  //#region Image base url CURD.
  public postImagePdfBlobType<T = any>(route: string, body: T): Observable<HttpResponse<any>> {
    return this.http.post(
      this.createCompleteImageDBRoute(route),
      body,
      {
        responseType: 'blob',
        observe: 'response', headers: {
          'Accept': 'application/pdf',
        }
      }
    );
  }

  public postImageBaseUrl<T = any>(route: string, body: T): Observable<HttpResponse<any>> {
    return this.http.post(
      this.createCompleteImageDBRoute(route),
      body,
      {
        observe: 'response', headers: httpHeaders
      }
    );
  }
  public postXMLBaseUrl<T = any>(route: string, body: T)   {
    return this.http.post(
      this.xmlPreview(route),
      body,{responseType:'text'}  
    );
  } 
  //sr1 start with  
  public postXML<T = any>(route: any, body: T) : Observable<HttpResponse<any>>  {
    return this.http.post(
      this.xmlPreview(route),
      body,{observe:'response'}  
    );
  }
  // end with Sr1 
  public getXMLBaseUrl<T = any>(route: string)   {
    return this.http.get(
      this.xmlPreview(route),
      {responseType:'text'}  
    );
  }
  //#endregion Image base url CURD.
  public postAIData(route: string, body): Observable<HttpResponse<any>> {
    return this.http.post(this.createAICompleteRoute(route),
        body, { observe: 'response', headers: httpHeaders});
  }
  public postImageData(route: string, body)  {
    return this.http.post(this.createCompleteImageDBRoute(route),body);
  }
  public getImageData(route: string)  {
    return this.http.get(this.createCompleteImageDBRoute(route));
  }

  getVideoData(route: string): Observable<Blob> {
    return this.http.get(this.createCompleteImageDBRoute(route), { responseType: 'blob' });
  }

  public deleteImageData(route: string)  {
    return this.http.delete(this.createCompleteImageDBRoute(route));
  }
  public postTransAIData(route: string, body) {
    // const formData = new FormData();
    // formData.append('file', audioFile,'audio.mp3');
    return this.http.post(this.createAICompleteRoute(route),
        body);
  }
  public postClinoteLoginData(route: string, body): Observable<HttpResponse<any>> {
    return this.http.post(this.createClinoteCompleteRoute(route),
        body, { observe: 'response', headers: httpHeaders});
  }
   public postFhirData(route: string, body) {    //y1 added fhir post data
    return this.http.post(route,body, {
      observe: 'response',
      headers: fhirHeaders
    });
  }
  private createCompleteRoute(route: string) {
    return `${AppConfigData.apiBaseUrl}/${route}`;
    // return `${environment.baseURL}/${route}`;
  }
  private createCompleteFHIRRoute(route: string) {
    return `${AppConfigData.fhirServer}/${route}`;
    return `${environment.fhirServer}/${route}`;
  }
  
  private createAICompleteRoute(route: string) {
    return `${AppConfigData.aiBaseURL}/${route}`;
    return `${environment.aiBaseURL}/${route}`;
  }
  private createClinoteCompleteRoute(route: string) {

    return `${AppConfigData.cliNoteUrl}/${route}`;
  }
  /**
   * Create complete image DB route.
   * @param route router path of controller and method name `string`.
   * @returns `string`.
   */
  private createCompleteImageDBRoute(route: string): string {
    return `${AppConfigData.imageBaseUrl}/${route}`;
    return `${environment.imageBaseUrl}/${route}`;
  }
  private xmlPreview(route: string): string {
    return `${AppConfigData.apiBaseUrl}/${route}`;
    return `${environment.baseURL}/${route}`;
  }
  public downloadPdf(route: string){
    return this.http.get<any>(this.createCompleteRoute(route),{ responseType: 'blob' as 'json', observe: 'response', headers: this.pdfHeader });
}
public validateCCDAFile(route: string,body){
  return this.http.post<any>(this.createCCDARoute(route),body,{ responseType: 'json', observe: 'response' });
}
public downloadPdfWithBody(route: string,body){
  return this.http.post<any>(this.createCompleteRoute(route),body,{ responseType: 'blob' as 'json', observe: 'response', headers: this.pdfHeader });
}
  public downloadPost(route: string,body){
    return this.http.post<any>(this.createCompleteRoute(route),body,{ responseType: 'blob' as 'json', observe: 'response', headers: this.expHeader });
}

  public postXMLData(route: string, body) {
    return this.http.post(this.createCompleteRoute(route), body, { responseType: 'text', observe: 'response',  headers: XML_HEADER });
  }

  public getXMLData(route: string) {
    return this.http.get(this.createCompleteRoute(route), { responseType: 'text', observe: 'response',  headers: XML_HEADER });
  }
  public getZIPData(route: string) {
    return this.http.get(this.createCompleteRoute(route), { responseType: 'blob', observe: 'response',  headers: ZIP_HEADER });
  }
  public getXMLDataDownload(route: string) {
    return this.http.get(this.createCompleteRoute(route), { responseType: 'blob', observe: 'response', headers: XML_HEADER })
  }
  public postXMLDataDownload(route: string,body) {
    return this.http.post(this.createCompleteRoute(route),body, { responseType: 'blob'  , headers: httpHeaders })
  }
  public getDataFromJsonAssets(fileName:string):Observable<HttpResponse<any>>{
    return this.http.get(`assets/data/${fileName}`,{ observe: 'response', headers: httpHeaders})
  }
  public getPdfData(route: string):Observable<HttpResponse<any>> {
    return this.http.get(this.createCompleteRoute(route), { responseType: 'blob', observe: 'response',  headers: downloadPdfhttpHeaders });
  }
  public getImage(route:string):Observable<HttpResponse<any>> {
   return this.http.get(this.createCompleteRoute(route), { responseType: 'blob' ,observe:'response'})
  }
  public postClinoteData(route: string, body) {
    return this.http.post(this.createClinoteCompleteRoute(route),body);
  }
  public gettClinoteData(route: string) {
    return this.http.get(this.createClinoteCompleteRoute(route));
  }
  /**
   * For text file get from assets.
   * @param fileName `file name - (string)`
   * @returns `Observable<HttpResponse<string>>`
   */
  public getDataTextFromAssets(fileName: string): Observable<HttpResponse<string>> {
    return this.http.get(`assets/data/${fileName}`, {
      responseType: 'text',
      observe: 'response'
    })
  }
  public openAiaudioStreaming(route,body) {
    return this.http.post(this.createOpenAICompleteRoute(route),body);
  }
  public openAipostData(route: string, body): Observable<HttpResponse<any>> {
    return this.http.post(this.createOpenAICompleteRoute(route),
        body, { observe: 'response', headers: httpHeaders});
  }
  private createOpenAICompleteRoute(route: string) {
    return `${AppConfigData.openAI}/${route}`; 
  }
  private createCCDARoute(route: string) {
    return `${AppConfigData.CCDAValidate}/${route}`;
  }
  public getDataFromJsonAssetsDocuments(fileName:string):Observable<HttpResponse<any>>{
    return this.http.get(`assets/documents/${fileName}`,{ observe: 'response', headers: httpHeaders})
  }
public getIpAddressData(){   //y1 added ipaddress url
  return this.http.get(this.getIpAddress(),{observe:'response',headers:httpHeaders})
}

  public getIpAddress():string{
    return `${AppConfigData.ipUrl}`;
  }
}
